const defaultSettings = {
  white: {
    pawn: {
      name: 'merida white pawn',
      description: 'default white pawn',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeigjnbrxk5inhyncznyxcn27f5lm2bxywcpmouiz7vx3sdjralpo4q.ipfs.dweb.link/wP.svg',
    },
    rook: {
      name: 'merida white rook',
      description: 'default white rook',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeiaiaclj2pqnrhje26wt56jyq576jmpvr647vcipyn5mgfgpzcea5q.ipfs.dweb.link/wR.svg',
    },
    knight: {
      name: 'merida white knight',
      description: 'default white knight',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeief2zzai7tysqaauoggrgbwfyjvqhoa5cwyfcnmugrshaxe4um53i.ipfs.dweb.link/wN.svg',
    },
    bishop: {
      name: 'merida white bishop',
      description: 'default white bishop',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeid3oafjq6n46kwryabdxtynx6w6hqojrzmcngh2jpwwfgelr55cca.ipfs.dweb.link/wB.svg',
    },
    queen: {
      name: 'merida white queen',
      description: 'default white queen',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeicf3wrfojytg4piktemw4s2m2tj43vbswptp7p5ndhyr3gmdkuwla.ipfs.dweb.link/wQ.svg',
    },
    king: {
      name: 'merida white king',
      description: 'default white king',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeifjmikxzu7a74uvjla345j56r7ejysdnxs75xjiqtke5wye3j5twm.ipfs.dweb.link/wK.svg',
    },
  },
  black: {
    pawn: {
      name: 'merida black pawn',
      description: 'default black pawn',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeicdcxcwxjworjosqhum72m3g5cpxdqdf3rembfetdfxgq5csf6s2q.ipfs.dweb.link/bP.svg',
    },
    rook: {
      name: 'merida black rook',
      description: 'default black rook',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeiajttej6j2o6q35niwo7qbkt7oyf44d4i5gfodo3i2b4uoicltpu4.ipfs.dweb.link/bR.svg',
    },
    knight: {
      name: 'merida black knight',
      description: 'default black knight',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeier4q2ghpgmvdnqcr73stzspfzrms5vqyel4iklokganyp5igom34.ipfs.dweb.link/bN.svg',
    },
    bishop: {
      name: 'merida black bishop',
      description: 'default black bishop',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeia522x74ydjj67olq5mq2jpan2s4dcamkttbwwiqad4c3immhz6l4.ipfs.dweb.link/bB.svg',
    },
    queen: {
      name: 'merida black queen',
      description: 'default black queen',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeicyty7k6ootiejrzdlo5y5ywdplrfwhqyo5e5yfinbnm6k3mrtmxu.ipfs.dweb.link/bQ.svg',
    },
    king: {
      name: 'merida black king',
      description: 'default black king',
      contract_address: '',
      token_id: '',
      image_url: 'https://bafybeihhagw4h2q4razxf4nvdyctvtebroqaddwxsw7xnrst75mklcqlvm.ipfs.dweb.link/bK.svg',
    },
  },
};

export default defaultSettings;
